<template>
  <div class="">
    <edit-breakdown> </edit-breakdown>
  </div>
</template>

<script>
import EditBreakdown from "@/components/profile/companies-products/breakdowns/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    EditBreakdown,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Scorpori",
        path: "module.PROF",
        tab: "#Breakdowns",
        level: 3,
      });
      bcs.push({
        text: "Modifica Scorpori",
        path: "breakdowns.edit",
        level: 4,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Scorpori",
        path: "module.PROF",
        tab: "#Breakdowns",
        level: 3,
      });
      this.notifyQueue({
        text: "Modifica Scorpori",
        path: "breakdowns.create",
        level: 4,
      });
    }
  },
};
</script>
